<script setup lang="ts">
import OHeader from '~/components/organisms/TheHeader.vue'
import RFooter from '~/components/organs/Footer.vue'
import OMobile from '~/components/organisms/Mobile.vue'
import { BIG_DESKTOP_WIDTH } from '~/static/window-sizing'

const isMobile = ref<boolean>(false)
const defineMobile = () => {
  isMobile.value = window.innerWidth <= BIG_DESKTOP_WIDTH
}

onMounted(() => {
  defineMobile()
  window.addEventListener('resize', defineMobile)
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', defineMobile)
})
</script>

<template>
  <div class="wrapper">
    <OHeader :is-editor="false" />
    <main>
      <slot v-if="!isMobile" />
      <ClientOnly v-else>
        <OMobile />
      </ClientOnly>
    </main>
    <RFooter />
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100dvh;

  main {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
  }
}
</style>
